export const guidesList = [
  {
    id: "g1",
    title: "雾泽全面培养攻略：武器、圣遗物与配队一次讲清",
    characterId: "mistveil",
    characterName: "雾泽",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20flowing%20water%20blade%20formation%20with%20teal%20light%20and%20rune%20patterns%2C%20elegant%20abstract%20magic%20concept%20art%2C%20painterly%20style&width=1000&height=560&seq=guide-cover-01&orientation=landscape",
    tags: ["角色攻略", "水元素", "输出"],
    date: "2026-10-12",
    readTime: "12 分钟",
    summary: "从武器选择、圣遗物词条到实战配队循环，一篇讲透雾泽的培养思路与常见误区。",
    sections: [
      {
        heading: "角色定位与养成优先级",
        paragraphs: [
          "雾泽是一名以水元素附魔普攻为核心输出手段的主 C 角色，其伤害来源高度集中于元素爆发期间的普攻连段。",
          "培养优先级建议为：等级突破 > 元素爆发天赋 > 普通攻击天赋 > 元素战技天赋。",
        ],
      },
      {
        heading: "武器选择建议",
        paragraphs: [
          "首选专武「雾切之回光」，其暴击伤害与元素加成能最大程度放大雾泽的爆发收益。",
          "无专武时，「波乱月白经津」与「磐岩结绿」都是优秀的替代选择，前者偏向暴击率，后者偏向生命值转化攻击。",
        ],
      },
      {
        heading: "圣遗物与词条搭配",
        paragraphs: [
          "推荐四件套「沉沦之心」，主词条为攻击 / 水伤 / 暴击。若队伍缺乏减抗手段，也可考虑「追忆之注连」四件套。",
          "副词条优先级：暴击伤害 > 暴击率 > 元素充能效率 > 攻击力百分比。",
        ],
      },
      {
        heading: "实战配队与循环",
        paragraphs: [
          "主流配队为「雾泽 + 岚心 + 蒹葭 + 磐岩」，先由辅助提供聚怪与增伤，再切换雾泽开启元素爆发进行输出。",
          "实战循环建议：岚心战技聚怪 → 蒹葭爆发上增益 → 磐岩战技开盾 → 雾泽战技接爆发输出。",
        ],
      },
    ],
    related: ["g3", "g6"],
  },
  {
    id: "g2",
    title: "烬珞火系站场输出指南：如何稳定触发蒸发反应",
    characterId: "emberlight",
    characterName: "烬珞",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20swirling%20flames%20and%20embers%20forming%20a%20spiral%20pattern%2C%20warm%20orange%20and%20crimson%20tones%2C%20abstract%20fire%20magic%20concept%20art%2C%20painterly%20style&width=1000&height=560&seq=guide-cover-02&orientation=landscape",
    tags: ["角色攻略", "火元素", "输出"],
    date: "2026-10-09",
    readTime: "10 分钟",
    summary: "详解烬珞的火元素附着节奏与蒸发反应触发技巧，解决站场输出断档问题。",
    sections: [
      {
        heading: "反应机制解析",
        paragraphs: [
          "烬珞的火元素附着以持续灼烧为主，配合水元素角色可以稳定触发蒸发反应，伤害提升约 1.5 倍。",
          "关键在于控制水元素附着的频率，避免水附着被火元素过快消耗。",
        ],
      },
      {
        heading: "武器与圣遗物",
        paragraphs: [
          "推荐武器「神乐之真意」，副词条为暴击率，能显著提升爆发期的稳定性。",
          "圣遗物推荐「炽烈的炎之魔女」四件套，主词条攻击 / 火伤 / 暴击。",
        ],
      },
      {
        heading: "配队思路",
        paragraphs: [
          "经典配队「烬珞 + 班尼特 + 香菱 + 万叶」，班尼特提供攻击力增益，香菱补充火元素覆盖，万叶负责聚怪与减抗。",
          "若缺乏万叶，可用风系辅助角色替代，但需注意减抗覆盖率。",
        ],
      },
    ],
    related: ["g4", "g1"],
  },
  {
    id: "g3",
    title: "岚心辅助手法教学：聚怪时机与减抗循环",
    characterId: "galeheart",
    characterName: "岚心",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20spiraling%20wind%20currents%20with%20green%20leaves%20and%20feathers%2C%20fresh%20mint%20and%20white%20tones%2C%20abstract%20wind%20magic%20concept%20art%2C%20painterly%20style&width=1000&height=560&seq=guide-cover-03&orientation=landscape",
    tags: ["角色攻略", "风元素", "辅助"],
    date: "2026-10-06",
    readTime: "8 分钟",
    summary: "聚怪、减抗、增伤三合一的岚心，其实手法细节很多，本文带你逐帧拆解。",
    sections: [
      {
        heading: "核心机制",
        paragraphs: [
          "岚心的风场不仅能够聚怪，还能通过翠绿之影四件套降低敌人对应元素抗性，是全队增伤的关键。",
          "减抗效果需要风场命中敌人才能触发，因此释放位置与时机非常重要。",
        ],
      },
      {
        heading: "手法与循环",
        paragraphs: [
          "标准起手：岚心战技聚怪 → 爆发持续吸引 → 切换主 C 输出。",
          "注意风场持续时间与冷却的衔接，避免出现聚怪真空期。",
        ],
      },
      {
        heading: "配装建议",
        paragraphs: [
          "武器可选择「若水」提升元素精通，或「终末嗟叹之诗」提供攻击力增益。",
          "圣遗物固定选择「翠绿之影」四件套，堆元素精通与元素充能效率。",
        ],
      },
    ],
    related: ["g1", "g6"],
  },
  {
    id: "g4",
    title: "深境螺旋第十二层满星思路：上半下半阵容拆解",
    characterId: "stormcaller",
    characterName: "雷鸣",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20glowing%20violet%20lightning%20arcs%20over%20an%20ancient%20arena%2C%20deep%20blue%20and%20violet%20tones%2C%20dramatic%20battle%20concept%20art%2C%20painterly%20fantasy%20style&width=1000&height=560&seq=guide-cover-04&orientation=landscape",
    tags: ["战斗攻略", "深渊", "阵容"],
    date: "2026-10-04",
    readTime: "11 分钟",
    summary: "本期深渊十二层环境偏向反应增伤，本文给出两套稳定满星的上下半阵容与应对要点。",
    sections: [
      {
        heading: "本期环境分析",
        paragraphs: [
          "深渊祝福提供元素爆发伤害加成，同时精英敌人拥有较高的元素抗性。",
          "上半建议使用水/火反应队伍，下半建议携带减抗辅助提升输出上限。",
        ],
      },
      {
        heading: "上半阵容推荐",
        paragraphs: [
          "推荐「雷鸣 + 班尼特 + 香菱 + 万叶」，依靠超载与聚怪快速清理小怪群。",
          "面对精英敌人时，先由万叶聚怪减抗，再由雷鸣开启爆发进行输出。",
        ],
      },
      {
        heading: "下半阵容推荐",
        paragraphs: [
          "推荐「雾泽 + 岚心 + 蒹葭 + 磐岩」，兼顾生存与持续输出。",
          "注意躲避精英敌人的范围技能，合理利用磐岩护盾抵挡关键伤害。",
        ],
      },
    ],
    related: ["g1", "g2"],
  },
  {
    id: "g5",
    title: "新玩家十四天养成路线：从零到打通主线",
    characterId: "seafoam",
    characterName: "蒹葭",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20young%20adventurer%20looking%20at%20a%20distant%20luminous%20mountain%2C%20golden%20hour%20light%20with%20soft%20cyan%20highlights%2C%20hopeful%20fantasy%20scene%2C%20painterly%20style&width=1000&height=560&seq=guide-cover-05&orientation=landscape",
    tags: ["新手攻略", "养成", "资源规划"],
    date: "2026-10-02",
    readTime: "14 分钟",
    summary: "专门写给新入坑玩家的两周养成计划，教你如何把有限资源花在刀刃上。",
    sections: [
      {
        heading: "第一周：主线与系统解锁",
        paragraphs: [
          "第一周的核心目标是推进主线并解锁元素反应、精炼、圣遗物等核心系统。",
          "建议优先完成主线第一章，同时不要忽视每日委托与周本。",
        ],
      },
      {
        heading: "第二周：养成与首抽规划",
        paragraphs: [
          "第二周开始分配资源培养主力角色，建议集中资源培养一名主 C 与一名治疗辅助。",
          "首抽建议留给当期强力五星角色，避免将原石分散投入多个卡池。",
        ],
      },
      {
        heading: "资源分配要点",
        paragraphs: [
          "树脂优先用于角色突破素材与天赋书。",
          "摩拉容易短缺，建议保留一定储备用于关键突破。",
        ],
      },
    ],
    related: ["g1", "g3"],
  },
  {
    id: "g6",
    title: "元素共鸣全解析：不同组合的收益与适用场景",
    characterId: "thornvine",
    characterName: "荆藤",
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20intertwining%20elemental%20energy%20ribbons%20in%20a%20dark%20starlit%20sky%2C%20multicilored%20sparkles%2C%20abstract%20magic%20concept%20art%2C%20painterly%20style&width=1000&height=560&seq=guide-cover-06&orientation=landscape",
    tags: ["机制解析", "配队", "入门"],
    date: "2026-09-29",
    readTime: "9 分钟",
    summary: "版本更新后元素共鸣数值被重新平衡，本文带你重新认识各组合的收益与取舍。",
    sections: [
      {
        heading: "什么是元素共鸣",
        paragraphs: [
          "当队伍中包含两名同元素角色时，会激活对应的元素共鸣效果，为全队提供额外增益。",
          "本次版本更新对多个共鸣数值进行了重新平衡，部分组合的优先级发生了变化。",
        ],
      },
      {
        heading: "主流共鸣效果对比",
        paragraphs: [
          "「坚定之岩」提供护盾与抗性，适合生存压力大的队伍。",
          "「交织之护」提供元素充能效率，适合依赖元素爆发的阵容。",
          "「热诚之火」提供攻击力增益，是输出队伍的高性价比选择。",
        ],
      },
      {
        heading: "如何选择共鸣",
        paragraphs: [
          "选择共鸣时应优先考虑队伍的输出循环是否顺畅，而非单纯追求面板加成。",
          "对于速切阵容，充能类共鸣往往比攻击类共鸣收益更高。",
        ],
      },
    ],
    related: ["g4", "g3"],
  },
];